/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAiUsageBilling extends models.GovernanceConfigurationBaseForCost {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAiUsageBilling");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAiUsageBilling.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAiUsageBilling>): GovernanceConfigurationForAiUsageBilling {
        let obj = Object.assign(new GovernanceConfigurationForAiUsageBilling(), model);
        GovernanceConfigurationForAiUsageBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAiUsageBilling>): GovernanceConfigurationForAiUsageBilling {
        if (!model) return null;
        return GovernanceConfigurationForAiUsageBilling.newInstance(<GovernanceConfigurationForAiUsageBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAiUsageBilling) {
        if (!obj) return;

        models.GovernanceConfigurationForAiUsageBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAiUsageBilling): boolean {
        if (models.GovernanceConfigurationBaseForCost.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAiUsageBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether AI usage cost attribution is performed for this account
     */
    enabled: boolean;

}
